module.exports = __webpack_public_path__ + "img/nft-id.3553d79a.gif";